import { tap, map, retry } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { updateCcToken } from '@store/actions/registration.actions';
import { State } from '../../store/app.state';
import { byPassAuthorization } from '../interceptors/http-context-tokens';

@Injectable({
  providedIn: 'root'
})
export class CcTokenService {

  private _apiUrl = environment.baseAPIUrl;

  constructor(private http: HttpClient,
    private _store: Store<State>) {

  }

  getCcToken(): Observable<string> {
    const body = new URLSearchParams();
    body.set('grant_type', environment.variables.ccToken.grant_type);
    body.set('client_id', environment.variables.ccToken.client_id);
    body.set('client_secret', environment.variables.ccToken.client_secret);
    body.set('scope', environment.variables.ccToken.scope);
    return this.http.post<string>(`${this._apiUrl}/connect/token`, body, { context: byPassAuthorization(), headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded') })
      .pipe(
        retry(3),
        tap(response => {

          this._store.dispatch(updateCcToken({ ccToken: response['access_token'] }))
        }),
        map(response => response['access_token'])
      )
  }

  storeToken(token: string) {
    this._store.dispatch(updateCcToken({ ccToken: token }))
  }

}
